import { RQService }            from '../../RQuery/RQuery';
import { Component }            from '@angular/core';
import { NavController }        from 'ionic-angular';
import { LoadingController }    from 'ionic-angular';
import { AlertController }      from 'ionic-angular';
import { PopoverController }    from 'ionic-angular';
import { dmHotel }              from '../sign-in/xv-hotel';
import { StaffViewModel }       from './xv-staff';
import { MLText, mlBroker }     from '../../services/MLText';
import { AppDataBroker }        from '../../services/AppData';
import { SignInPage }           from '../sign-in/sign-in';
import { dmLoading }            from '../loading/loading';
import { ChangePINPopoverPage } from './change-pin-popover';

@Component({
     selector:    'page-staff'
    ,templateUrl: 'staff.html'
})
export class StaffPage {
    Staff:         StaffViewModel;
    ShowAlert:     (pTitle: string, pMessage: string)    => void;
    NewLoading:    (pMessage: string)                    => dmLoading;
    ShowChangePIN: (pStaff: RQService.Tasks.GetStaffRow) => void;
    BackToSignIn:  ()                                    => void;

    app:          mlBroker;

    constructor(
         public navCtrl:       NavController
        ,public alertCtrl:     AlertController
        ,public loadingCtrl:   LoadingController
        ,public popoverCtrl:   PopoverController
        ,public mlText:        MLText
        ,public appDataBroker: AppDataBroker
    ) {
        let hotel       = appDataBroker.GetAppData() as dmHotel;

        this.app        = this.mlText.GetBroker('BookingEngineAppTexts');

        this.ShowAlert  = (pTitle: string, pMessage: string) => {
            let alert   = this.alertCtrl.create({
                 title:   pTitle
                ,message: pMessage
                ,buttons: [
                    {
                         text:    this.app.Text('OK')
                        ,handler: () => { return true; }
                    }
                ]
            });

            alert.present();
        };

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.ShowChangePIN = (pStaff: RQService.Tasks.GetStaffRow) => {
            if (
                this.mlText.IsViewLangLoaded(
                    'CTMExtranetStaff'
                    ,this.mlText.GetLangID()
                )
            ) {
                let popover = this.popoverCtrl.create(
                     ChangePINPopoverPage
                    ,{ staff: pStaff }
                );

                popover.present();

                return;
            }

            let loading: dmLoading = this.NewLoading(
                this.app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                this.mlText.LoadView(this.mlText.GetLangID() ,'CTMExtranetStaff' ,() => {
                    loading.Dismiss();
                
                    let popover = this.popoverCtrl.create(
                         ChangePINPopoverPage
                        ,{ staff: pStaff }
                    );
                
                    popover.present();
                });
            });
        };

        this.BackToSignIn = () => {
            this.navCtrl.setRoot(SignInPage);
        };

        this.Staff = new StaffViewModel(
             mlText
            ,hotel
            ,this.BackToSignIn
            ,this.ShowAlert
            ,this.NewLoading
            ,this.ShowChangePIN
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/staff/staff.ts